/**
 * Tracker plano para medir engagement_time_msec en el modo Mundial.
 *
 * Uso:
 *   - Llamar startEngagement() al MOUNT del container Mundial2026.
 *   - Llamar resetEngagement() en el cleanup (al UNMOUNT).
 *   - Llamar getEngagementTime() para obtener el tiempo transcurrido en ms.
 *
 * Si nunca se inició, getEngagementTime() devuelve 0.
 */
let startTime = null;

export const startEngagement = () => {
  startTime = Date.now();
};

export const getEngagementTime = () => {
  return startTime ? Date.now() - startTime : 0;
};

export const resetEngagement = () => {
  startTime = null;
};
